export const SOCIAL_LINKS = {
    FACEBOOK: "https://facebook.com/your-page",
    TIKTOK: "https://tiktok.com/@your-account",
};

export const CONTACT_INFO = {
    HOTLINE: "0912 531 059",
    PHONE: "0912 531 059",
    EMAIL: "contact@example.com",
    ADDRESS: "Số 33, ngách 43, Cổ Nhuế, Bắc Từ Liêm, Hà Nội",
};

export const ROUTES = {
    HOME: "/",
    CART: "/cart",
    PRODUCTS: "/products",
    ABOUT: "/about",
    CONTACT: "/contact",
};

export const SAMPLE_VIDEO_URL = "https://example.com/sample-video.mp4";

// Placeholder cho các hình ảnh
export const PLACEHOLDER_IMAGES = {
    PRODUCT: "/api/placeholder/120/120",
    BANNER: "/api/placeholder/1200/400",
    LOGO: "/api/placeholder/200/80",
};

// API Endpoints
export const API = {
    BASE_URL: "https://api.emboxvn.com",
    ORDER: {
        CREATE: "/order/create"
    }
};
